import {NavItem, NavSection} from "~/components/header/collapsed-header/subnavigation/common";
import * as React from "react";
import {useTranslation} from "react-i18next";

export function ProductsSubSection({ close}: {close: () => void}) {
    const { t } = useTranslation("common");
    const comingSoon = t("subnav.products.coming_soon");

    return (
        <NavSection value="products" label={t("nav.products")}>
            <NavItem label={t("subnav.products.drive.name")} to="/products/drive" onClick={close} />
            <NavItem label={t("subnav.products.view.name")} to="/products/view" badge={comingSoon} onClick={close} />
            <NavItem label={t("subnav.products.go.name")} to="/products/go" onClick={close} />
            <NavItem label={t("nav.shop_all_products")} to="/products" onClick={close} />
        </NavSection>
)}
